import { render, staticRenderFns } from "./textarea-row.vue?vue&type=template&id=50585e0e&"
import script from "./textarea-row.vue?vue&type=script&lang=js&"
export * from "./textarea-row.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports